import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/tableConstants/API";

export interface ValidationErrorResponse {
  status: "error";
  message: string;
  expected_columns: string[];
  uploaded_columns: string[];
  mismatches: {
    position: number;
    expected: string;
    actual: string;
  }[];
}
export interface BookBubdata {
  columns: string[];
  values: any[];
  offset: number;
  limit: number;
  total_pages: number;
  page: number;
  hasMore: boolean;
}
interface OptionType {
  value: string;
  label: string;
}
interface sortObj {
  heading: string;
  sortType: string;
}

interface BookBubState {
  BookBubData: BookBubdata | null | any;
  dataTemplate: any;
  DataForInfo: any;
  loading: boolean;
  error: null | any;
  offset: any;
  ValidationOfFileBookBub: any;
  validationError: ValidationErrorResponse | null | any;
  validationStatus: "idle" | "loading" | "success" | "error" | any;
  uploadFileDataBookBub: number[] | string[];
BookBubColumns: any,
  BookBubows: any,
  ValidationLoading: boolean;
  message: string;
  hasMore: boolean;
  currentPageBookBub: number;
  uploadFileData: any;
  isSubmitDisabledForPreview: boolean;
  isUploading: boolean;
  titleSortByBookBub: sortObj;
  detail: any;
  selectedIsbnListBookBub?: OptionType[];
  selectedTitleListBookBub?: OptionType[];
  selectedDealBookBub?: OptionType[];
  columnsSort: any;
  PreviewExistingPopupOpenBookBub: boolean;
  sortStateBookBub?: sortObj;
  filename: any;
  scrolling: boolean;
  GetKddIconData: any;
  limit: number;
  status: number;
  totalItems: any;
  BookBubLoading: boolean;
  success: boolean;
  loadingOfBookbubTable:boolean;
}

const initialState: BookBubState = {
  dataTemplate: null,
  BookBubData:null,
  DataForInfo: null,
  loading: false,
  status: 0,
  error: null,
  ValidationOfFileBookBub: "",
  validationError: null,
  validationStatus: "idle",
  uploadFileDataBookBub: [],
 BookBubColumns: [],
  BookBubows: [],
  message: "",
  ValidationLoading: false,
  hasMore: false,
  currentPageBookBub: 1,
  uploadFileData: [],
  isSubmitDisabledForPreview: false,
  offset: 0,
  limit: 10,
  totalItems: 10,
  isUploading: false,
  titleSortByBookBub: {
    heading: "",
    sortType: "asc",
  },
  detail: "",
selectedIsbnListBookBub:[],
  selectedTitleListBookBub: [],
  selectedDealBookBub: [],
  columnsSort: {},
  PreviewExistingPopupOpenBookBub: false,
  sortStateBookBub: {
    heading: "ISBN",
    sortType: "desc",
  },
  filename: "",
  scrolling: false,
  GetKddIconData: [],
  BookBubLoading: false,
  success: false,
  loadingOfBookbubTable:false
};
export const FetchBookBubTemplate = createAsyncThunk(
  "/template",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(API.GetbookBubTemplate, {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      // Set filename from backend header
      const contentDisposition = response.headers["content-disposition"];
      let fileName = "BookBubTemplate.xlsx";
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match?.[1]) fileName = match[1];
      }

      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();

      return { success: true };
    } catch (err) {
      return thunkAPI.rejectWithValue("Error downloading file");
    }
  }
);

export const FetchBookBubInfo = createAsyncThunk(
  "/FetchBookBubInfo",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(API.GetBookBubInfo, {
        responseType: "blob",
      });

      // Create a blob URL for the file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      // Try to get filename from response headers
      const contentDisposition = response.headers["content-disposition"];
      let fileName = "BookBubInfo.xlsx"; // fallback
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match?.[1]) fileName = match[1];
      }

      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();

      return { success: true };
    } catch (err) {
      return thunkAPI.rejectWithValue("Error downloading file");
    }
  }
);
export const uploadFileBookBub = createAsyncThunk(
  "uploadFileBookBub",
  async (formData: FormData, thunkAPI) => {
    try {
      const response = await axios.post(`${API.UploadFileBookBub}`, formData);
      console.log(response, "response");
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || "Upload failed");
    }
  }
);

// Fetch ASAP data with pagination
export const fetchBookBubDataPagination = createAsyncThunk<
  BookBubdata,
  {
    page?: number;
    limit?: number;
    heading?: string;
    sortType?: string;
    filters?: { TITLE?: any; ISBN?: any; DEAL_DATE?: any };
  }
>(
  "data/fetchBookBubDataPagination",
  async (
    
    {  page = 1,
      limit = 10,
      heading = "",
      sortType = "asc",
      filters = {},
    },
    { rejectWithValue }
  ) => {
    try {
      const payload = {
        page,
        limit,
        heading,
        sortType,
        filters,
      };
      console.log("API request payload:", payload);
      const response = await axios.post<BookBubdata>(
        `${API.GetBookBubDataInTable}`,
        payload
      );
      console.log("API response:", response.data);
      return response.data;
    } catch (err: any) {
      console.error("API error:", err.response?.data);
      return rejectWithValue(
        err.response?.data?.message || "Something went wrong"
      );
    }
  }
);

const BookBupSlice = createSlice({
  name: "BookBub",
  initialState,
   reducers: {
    setBookBubColumns: (state, action) => {
      state.BookBubColumns = action.payload;
    },
    setBookBubRows: (state, action) => {
      state.BookBubows = action.payload;
    },
    clearBookBubData: (state) => {
      state.BookBubData = { values: [], columns: [] };
    },
    clearValidatorErrors: (state) => {
      state.validationError = null;
      state.validationStatus = null;
    },
    setCurrentPageBookBub: (state, action) => {
      console.log("currentPageinReducer is being set", action.payload);
      state.currentPageBookBub = action.payload;
    },
    setIsSubmitDisabledForPreview: (state, action) => {
      state.isSubmitDisabledForPreview = action.payload;
      console.log("Set Disabled For Preview:", action.payload);
    },
    setIsUploading: (state, action) => {
      state.uploadFileData = action.payload;
    },
    titleListSortByDesc: (state, action) => {
      state.titleSortByBookBub = action.payload;
      console.log(action.payload, "titlesortby");
    },
    setValidationError: (state, action) => {
      state.validationError = action.payload;
    },
    resetBookBubPagination: (state) => {
      state.BookBubData = null;
      state.currentPageBookBub= 1;
      state.error = null;
    },
    resetValidationError: (state) => {
      state.validationError = null;
      state.validationStatus = "idle";
      state.ValidationLoading = false;
      state.detail = null;
    },
    resetFilterStateBookBub:(state,action)=>{
state.selectedDealBookBub=action.payload;
state.selectedIsbnListBookBub=action.payload;
state.selectedTitleListBookBub=action.payload;
state.sortStateBookBub=initialState.sortStateBookBub
    },
    updateselectedTitleListBookBub: (state, action) => {
      state.selectedTitleListBookBub = action.payload;
    },
    updateselectedISBNListBookBub: (state, action) => {
      state.selectedIsbnListBookBub = action.payload;
    },
    updateselectedDealBookBub: (state, action) => {
      state.selectedDealBookBub = action.payload;
    },
    resetSEGPage: (state) => {
      state.currentPageBookBub = initialState.currentPageBookBub;
    },
    setSortDirection: (
      state,
      action: PayloadAction<{ column: string; sortType: "asc" | "desc" }>
    ) => {
      const { column, sortType } = action.payload;
      state.columnsSort[column] = sortType;
    },
    setPreviewExistingPopupOpenForBookBub: (state, action) => {
      state.PreviewExistingPopupOpenBookBub = action.payload;
    },
    SetsortStateBookBub: (state, action: PayloadAction<sortObj>) => {
      state.sortStateBookBub = action.payload;
    },
    setscrolling: (state, action) => {
      state.scrolling = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    clearBookBubState: (state) => {
      state.BookBubColumns = [];
      state.BookBubows = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(FetchBookBubTemplate.pending, (state, action) => {
        state.loading = true;
        state.error = "error";
      })
      .addCase(FetchBookBubTemplate.fulfilled, (state, action) => {
        state.dataTemplate = action.payload;
        console.log(action.payload, "FtehcbookBub");
        state.loading = false;
        state.success = true;
      })
      .addCase(FetchBookBubTemplate.rejected, (state) => {
        state.loading = false;
      })
      .addCase(FetchBookBubInfo.pending, (state, action) => {
        state.loading = true;
        state.error = "error";
      })
      .addCase(FetchBookBubInfo.fulfilled, (state, action) => {
        state.DataForInfo = action.payload;
        console.log(action.payload, "FtehcbookBub");
        state.loading = false;
        state.success = true;
      })
      .addCase(FetchBookBubInfo.rejected, (state) => {
        state.loading = false;
      })
      .addCase(uploadFileBookBub.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadFileBookBub.fulfilled, (state, action) => {
        state.loading = false;
        state.uploadFileDataBookBub = action.payload;
        state.message = action.payload.message;
        console.log(action.payload, "uploadapi");
      })
      .addCase(uploadFileBookBub.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(fetchBookBubDataPagination.pending, (state) => {
        state.BookBubLoading = true;
        state.loading = true;
        state.loadingOfBookbubTable = true;
        state.error = null;
      })
      .addCase(fetchBookBubDataPagination.fulfilled, (state, action) => {
        state.loading = false;
        state.loadingOfBookbubTable = false;
        state.BookBubLoading = false;
        state.hasMore = action.payload.hasMore;
        // state.currentPage = action.payload.page;
        console.log("currentPageinReducer", state.currentPageBookBub);
        if (state.currentPageBookBub == 1 || !state.BookBubData) {
          state.BookBubData = action.payload;
        } else {
          state.BookBubData = {
            ...action.payload,
            values: [...state.BookBubData.values, ...action.payload.values],
          };
        }
      })
      .addCase(fetchBookBubDataPagination.rejected, (state, action) => {
        state.loading = false;
        state.loadingOfBookbubTable = false;
        state.BookBubLoading = false;
        state.error = action.payload as string;
      });
  },
});
export const {setBookBubColumns,
  setBookBubRows,
  clearBookBubState,
  clearValidatorErrors,
  setIsSubmitDisabledForPreview,
  setIsUploading,
  titleListSortByDesc,
  setValidationError,
  setCurrentPageBookBub,
  resetValidationError,
  resetBookBubPagination,
  resetSEGPage,
  setSortDirection,
  setPreviewExistingPopupOpenForBookBub,
  SetsortStateBookBub,
  setscrolling,
  setLoading,updateselectedTitleListBookBub,updateselectedDealBookBub,updateselectedISBNListBookBub,resetFilterStateBookBub
 } = BookBupSlice.actions;
export default BookBupSlice.reducer;
